import React from 'react';
import Wrapper from '@common/pages/Wrapper';
import TabsComponent, {TabProps} from "@common/TabsComponent";
import CareJourneysTab from "@/components/pages/tasks/CareJourneysTab";
import {FeatureToggle} from '@/api/dto/dto';
import ProviderReferralsTab from "@/components/pages/tasks/ProviderReferralsTab";
import {useFeatureToggles} from "@/hooks/useFeatureToggles";

export default function TaskPage() {
  const {checkBooleanToggle} = useFeatureToggles();
  const showProviderReferrals = checkBooleanToggle(FeatureToggle.CARECO_5541_CARE_JOURNEY_PRE_REVIEW);

  const tabs: TabProps[] = [
    {
      value: 0,
      label: 'Care Journeys',
      route: '/tasks/care_journeys',
      content: <CareJourneysTab/>
    },
  ];

  // Only hide the Provider Referrals tab once the feature-toggle query has resolved to false. While
  // it is still unresolved, checkBooleanToggle returns undefined (not false) — keep the tab in that
  // window so a deep link to /tasks/provider_referrals is preserved instead of being redirected away
  // (and history-replaced) before the toggle loads.
  if (showProviderReferrals !== false) {
    tabs.push({
      value: 1,
      label: 'Provider Referrals',
      route: '/tasks/provider_referrals',
      content: <ProviderReferralsTab/>
    });
  }

  return (
    <Wrapper>
      <TabsComponent tabs={tabs} />
    </Wrapper>
  );
}
